module.exports = __webpack_public_path__ + "891e3f340c1126b4c7c142e5f6e86816.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./~/font-awesome/fonts/fontawesome-webfont.woff?v=4.6.1
 ** module id = 116
 ** module chunks = 0
 **/